import { render, staticRenderFns } from "./NgSwitch.vue?vue&type=template&id=a716e958"
import script from "./NgSwitch.vue?vue&type=script&lang=js"
export * from "./NgSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports